var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.isSdkReady)?_c('div',{staticClass:"test"},[_c('button',{on:{"click":_vm.handleTest1}},[_vm._v("朋友别走")]),_c('button',{on:{"click":_vm.handleTest2}},[_vm._v("友谊长存")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }